module.exports = __webpack_public_path__ + "img/appdownloadqr.3f33e8f9.png";